/* src/app/modules_v2/contacts/components/contact-form/contact-general-form/contact-general-form.component.css */
/*# sourceMappingURL=contact-general-form.component.css.map */
